import React from 'react';
import { FaUniversity, FaMicroscope, FaHandshake, FaAward } from 'react-icons/fa';

const reasons = [
  { icon: <FaUniversity size={28} />, title: 'AIIMS-Trained Neurologist',  desc: "DM Neurology from India's most prestigious institution — the highest neurological qualification available." },
  { icon: <FaMicroscope size={28} />, title: 'Advanced Diagnostics',        desc: 'EEG, NCS/EMG, and neuroimaging interpretation all available under one roof.' },
  { icon: <FaHandshake size={28} />,  title: 'Patient-First Approach',      desc: "Compassionate, evidence-based care tailored to each patient's unique neurological condition." },
  { icon: <FaAward size={28} />,      title: 'Super-Specialist Care',       desc: 'Triple qualification — MBBS, MD, and DM — ensuring the highest level of neurological expertise.' },
];

const WhyUs = () => (
  <section id="why-us" className="why-us">
    <div className="container">
      <div className="section-header">
        <div className="section-tag">Why Choose Us</div>
        <h2 className="section-title why-title">Trusted by Thousands in Nashik</h2>
        <p className="section-desc" style={{ color: 'rgba(255,255,255,0.65)' }}>
          What sets Naik Neuro Clinic apart from the rest.
        </p>
      </div>
      <div className="reasons-grid">
        {reasons.map(r => (
          <div key={r.title} className="reason-card">
            <div className="reason-icon">{r.icon}</div>
            <h3 className="reason-title">{r.title}</h3>
            <p className="reason-desc">{r.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
